export default {
	profile: {
		username: 'Nombre de usuario',
		oldPassword: 'Contraseña original',
		newPassword: 'Nueva contraseña',
		confirmPassword: 'Confirmar contraseña'
	}
}
